import { Orientation } from "@/types/types";
import styles from "./orientation-view.module.css";
import { useTranslations } from "next-intl";
import { MdErrorOutline } from "react-icons/md";

export default function OrientationSelector({
  currentOrientation,
  error,
  onClick,
}: {
  currentOrientation: Orientation;
  error: string | undefined;
  onClick: (newValue: Orientation) => void;
}) {
  const t = useTranslations("NewListing.Orientation");

  return (
    <div id="orientation" className={styles.inputItem}>
      <h3 className={`${styles.fieldTitle} ${error && styles.error}`}>
        {t("orientationTitle")}
      </h3>
      {error ? (
        <p className={styles.errorText}>
          {t(error)}
          <span>
            <MdErrorOutline />
          </span>
        </p>
      ) : (
        <p className={styles.fieldDescription}>{t("orientationDescription")}</p>
      )}
      <ul className={styles.wrapper}>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentOrientation,
                north: !currentOrientation.north,
              });
            }}
            className={`${styles.pill} ${
              currentOrientation.north ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("north")}
          </button>
        </li>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentOrientation,
                south: !currentOrientation.south,
              });
            }}
            className={`${styles.pill} ${
              currentOrientation.south ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("south")}
          </button>
        </li>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentOrientation,
                east: !currentOrientation.east,
              });
            }}
            className={`${styles.pill} ${
              currentOrientation.east ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("east")}
          </button>
        </li>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentOrientation,
                west: !currentOrientation.west,
              });
            }}
            className={`${styles.pill} ${
              currentOrientation.west ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("west")}
          </button>
        </li>
      </ul>
    </div>
  );
}
